"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var react_vertical_timeline_component_1 = require("react-vertical-timeline-component");

require("react-vertical-timeline-component/style.min.css");

var constants_1 = require("../../../constants");

var Card_1 = __importDefault(require("../../Card"));

var Detail_1 = __importDefault(require("../../Card/Detail"));

var Header_1 = __importDefault(require("../../Card/Header"));

var Image_1 = __importDefault(require("../../Card/Image"));

var Pill_1 = __importDefault(require("../../Card/Pill"));

var Section_1 = __importDefault(require("../../Card/Section"));

var Base_1 = __importDefault(require("../Base"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * General Timeline card layout Moment.
 */


var TimelineMoment = function TimelineMoment(props) {
  var bodyClassName = props.bodyClassName,
      color = props.color,
      data = props.data;
  var classes = (0, useStyles_1.default)();

  var renderCard = function renderCard(_a) {
    var date = _a.date,
        description = _a.description,
        image = _a.image,
        title = _a.title,
        website = _a.website;
    return react_1.default.createElement(Card_1.default, null, image && react_1.default.createElement(Image_1.default, {
      alt: title,
      src: image
    }), react_1.default.createElement(Header_1.default, {
      text: title
    }), react_1.default.createElement(Divider_1.default, null), react_1.default.createElement(Section_1.default, null, react_1.default.createElement(Pill_1.default, {
      text: date.label
    })), description && react_1.default.createElement(Detail_1.default, null, description), website && react_1.default.createElement(Detail_1.default, null, react_1.default.createElement(Button_1.default, {
      className: "library-sidebar-link",
      href: website,
      target: "_blank",
      variant: "contained"
    }, "Learn More")));
  };

  return (
    /* eslint-disable react/jsx-props-no-spreading */
    react_1.default.createElement(Base_1.default, __assign({}, props, {
      bodyClassName: classes.root + " " + bodyClassName
    }), react_1.default.createElement(react_vertical_timeline_component_1.VerticalTimeline, null, data.map(function (ctx) {
      return react_1.default.createElement(react_vertical_timeline_component_1.VerticalTimelineElement, {
        className: "story-timeline__element",
        icon: react_1.default.createElement("div", {
          className: "story-timeline__element__icon",
          style: {
            alignItems: 'center',
            display: 'flex',
            height: '100%'
          }
        }, react_1.default.createElement("div", {
          style: {
            fontWeight: 800,
            textAlign: 'center',
            width: '100%'
          }
        }, ctx.date.year)),
        iconStyle: {
          background: color.background,
          color: color.text
        },
        key: ctx.date.year + "-" + ctx.title,
        style: {
          padding: 0
        }
      }, renderCard(ctx));
    })))
  );
};

TimelineMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Determines the Timeline information to use. */
  data: prop_types_1.default.arrayOf(prop_types_1.default.object),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: prop_types_1.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
TimelineMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.Timeline,
  type: constants_1.MomentType.Timeline
});
exports.default = TimelineMoment;